/**
 * Single source for "new theme" detection in Grunt-concatenated scripts (bq-core, vendor.js, etc.).
 * Uses bq.react.settings.theme_style when set, otherwise body classes.
 *
 * Does not call window.getIsThemeNew — react/lib/theme.js assigns that to a function which delegates
 * here when bq.getIsThemeNew exists, avoiding circular delegation.
 */
bq.getIsThemeNew = function () {
  var themeStyle =
    typeof bq !== "undefined" && bq.react && bq.react.settings
      ? bq.react.settings.theme_style
      : null;
  if (themeStyle) {
    return ["theme-new", "light-theme", "dark-theme"].indexOf(themeStyle) !== -1;
  }
  var $jq = typeof window !== "undefined" && (window.jQuery || window.$ || window.$j);
  return !!($jq && $jq.fn && $jq("body").is(".theme-new, .light-theme, .dark-theme"));
};
